import { parseAsString, useQueryState } from 'nuqs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBranches } from '@/lib/org';

const ALL = 'all';

/** Unidade na URL (?unidade=). Com `required`, o padrão é a primeira unidade ativa; sem, "todas". */
export function useUnitParam(required = false) {
  const branches = useBranches();
  const [param, setParam] = useQueryState('unidade', parseAsString.withOptions({ history: 'replace' }));
  const list = (branches.data ?? []).filter((b) => b.active);
  const valid = param && list.some((b) => b.id === param) ? param : null;
  const branchId = valid ?? (required ? (list[0]?.id ?? null) : null);
  return { branches: list, branchId, setBranchId: (id: string | null) => setParam(id), isLoading: branches.isLoading, error: branches.error, refetch: branches.refetch };
}

export function UnitSelect({
  branches,
  value,
  onChange,
  allowAll = false,
  id = 'unit-select',
}: {
  branches: { id: string; name: string }[];
  value: string | null;
  onChange: (id: string | null) => void;
  allowAll?: boolean;
  id?: string;
}) {
  if (!allowAll && branches.length <= 1) return null;
  return (
    <Select value={value ?? ALL} onValueChange={(v) => onChange(v === ALL ? null : v)}>
      <SelectTrigger id={id} aria-label="Unidade" className="w-48">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {allowAll && <SelectItem value={ALL}>Todas as unidades</SelectItem>}
        {branches.map((b) => (
          <SelectItem key={b.id} value={b.id}>
            {b.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
